import { IconType } from '../../models/notification.model';
import { Component, Input } from '@angular/core';
import { HandsetService } from '../../../core/services/handset.service';

@Component({
standalone: false,
  selector: 'app-notifications-icon',
  styleUrls: ['./notifications-icon.component.scss'],
  templateUrl: './notifications-icon.component.html',
})
export class NotificationsIconComponent {
  @Input() iconType: IconType;

  public readonly IconType = IconType;

  constructor(public handsetService: HandsetService) {}
}
